export default __webpack_public_path__ + "rocket_icon.3125c9e6.svg";